// NewAudia App Constants
// Promo codes and other configurable values are defined here.
// Update this file to change values platform-wide — do not hardcode these values elsewhere.

export const PREVIEW_PROMO_CODE = "NA2026";
